import {UserIcon} from "@pg-design/icons-module";
import {kmAppLink} from "@pg-mono/km-routes";
import {noop} from "@pg-mono/nodash";

import {UserIconPopover} from "../components/UserIconPopover";
import {INavMiddleElement, INavRightElement} from "../Navigation";
import {getFullKMLink} from "../utils/get_full_km_link";
import {useUserPopover} from "./use_user_popover";

export type UseNavigationUserElementsParams = {
    recommendedCount: number;
    kmUrl: string;
    rpUrl?: string;
    onLogin: (e: React.MouseEvent<HTMLElement>) => void;
    onLogout: (e: React.MouseEvent<HTMLElement>) => void;
    isAuthenticated: boolean;
    isMobile: boolean;
    allowPopoverActivation: boolean;
};

export const useNavigationUserElements = (
    params: UseNavigationUserElementsParams
): {
    navRightElements: INavRightElement[];
    navMobileMiddleElements: INavMiddleElement[];
} => {
    const {isPopoverActive, onPopoverClose, onHoverUserIcon} = useUserPopover();

    const hasRecommendations = params.recommendedCount > 0;

    const authenticatedUserNavigationField = {
        title: "Twoje Konto",
        icon: <UserIcon size={params.isMobile ? "2" : "2.5"} />,
        url: getFullKMLink(params.kmUrl, kmAppLink.site.offers.appliedWithParams),
        subElements: [
            {
                title: "Moje zapytania",
                url: getFullKMLink(params.kmUrl, kmAppLink.site.offers.appliedWithParams),
                target: "_blank"
            },
            {
                title: "Ustawienia konta",
                url: getFullKMLink(params.kmUrl, kmAppLink.site.user.baseWithParams),
                target: "_blank"
            },
            {
                title: "Wyloguj",
                onClick: params.onLogout
            }
        ]
    };

    const unauthenticatedUserNavigationField = {
        title: "Twoje Konto",
        rel: "nofollow",
        icon: <UserIconPopover isPopoverActive={isPopoverActive} onPopoverClose={onPopoverClose} />,
        onClick: params.onLogin,
        onHover: params.allowPopoverActivation ? onHoverUserIcon : noop
    };

    return {
        navRightElements: [params.isAuthenticated ? authenticatedUserNavigationField : unauthenticatedUserNavigationField],
        navMobileMiddleElements: [
            params.isAuthenticated
                ? {
                      ...authenticatedUserNavigationField,
                      onClick: () => {
                          if (params.isMobile) {
                              window.location.href = getFullKMLink(
                                  params.kmUrl,
                                  hasRecommendations ? kmAppLink.site.offers.baseWithParams : kmAppLink.site.user.baseWithParams
                              );
                          }
                      }
                  }
                : unauthenticatedUserNavigationField
        ]
    };
};
import {UserIcon} from "@pg-design/icons-module";
import {kmAppLink} from "@pg-mono/km-routes";
import {noop} from "@pg-mono/nodash";

import {UserIconPopover} from "../components/UserIconPopover";
import {INavMiddleElement, INavRightElement} from "../Navigation";
import {getFullKMLink} from "../utils/get_full_km_link";
import {useUserPopover} from "./use_user_popover";

export type UseNavigationUserElementsParams = {
    recommendedCount: number;
    kmUrl: string;
    rpUrl?: string;
    onLogin: (e: React.MouseEvent<HTMLElement>) => void;
    onLogout: (e: React.MouseEvent<HTMLElement>) => void;
    isAuthenticated: boolean;
    isMobile: boolean;
    allowPopoverActivation: boolean;
};

export const useNavigationUserElements = (
    params: UseNavigationUserElementsParams
): {
    navRightElements: INavRightElement[];
    navMobileMiddleElements: INavMiddleElement[];
} => {
    const {isPopoverActive, onPopoverClose, onHoverUserIcon} = useUserPopover();

    const hasRecommendations = params.recommendedCount > 0;

    const authenticatedUserNavigationField = {
        title: "Twoje Konto",
        icon: <UserIcon size={params.isMobile ? "2" : "2.5"} />,
        url: getFullKMLink(params.kmUrl, kmAppLink.site.offers.appliedWithParams),
        subElements: [
            {
                title: "Moje zapytania",
                url: getFullKMLink(params.kmUrl, kmAppLink.site.offers.appliedWithParams),
                target: "_blank"
            },
            {
                title: "Ustawienia konta",
                url: getFullKMLink(params.kmUrl, kmAppLink.site.user.baseWithParams),
                target: "_blank"
            },
            {
                title: "Wyloguj",
                onClick: params.onLogout
            }
        ]
    };

    const unauthenticatedUserNavigationField = {
        title: "Twoje Konto",
        rel: "nofollow",
        icon: <UserIconPopover isPopoverActive={isPopoverActive} onPopoverClose={onPopoverClose} />,
        onClick: params.onLogin,
        onHover: params.allowPopoverActivation ? onHoverUserIcon : noop
    };

    return {
        navRightElements: [params.isAuthenticated ? authenticatedUserNavigationField : unauthenticatedUserNavigationField],
        navMobileMiddleElements: [
            params.isAuthenticated
                ? {
                      ...authenticatedUserNavigationField,
                      onClick: () => {
                          if (params.isMobile) {
                              window.location.href = getFullKMLink(
                                  params.kmUrl,
                                  hasRecommendations ? kmAppLink.site.offers.baseWithParams : kmAppLink.site.user.baseWithParams
                              );
                          }
                      }
                  }
                : unauthenticatedUserNavigationField
        ]
    };
};
